import script from "./HrSidebar.vue?vue&type=script&setup=true&lang=js"
export * from "./HrSidebar.vue?vue&type=script&setup=true&lang=js"

import "./HrSidebar.vue?vue&type=style&index=0&id=4a9f198b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4a9f198b"]])

export default __exports__